import { combineReducers } from 'redux';
import newsManagement from '../screens/NewsManagement/reducers/';
import latestNews from '../screens/LatestNews/reducers/';
export default combineReducers({
  newsManagement,
  latestNews,
});



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/CompanyNews/reducers/index.js
 **/